import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import { makePOSTRequestOnUserService } from "../../Api/api";
import toastr from "toastr";

const SendAnnualStatement = () => {
  const [loading, setLoading] = useState(false);

  const send = () => {
    setLoading(true);
    makePOSTRequestOnUserService(
      "order_management_v2/sent_user_annual_statement/"
    )
      .then((response) => {
        if (response && response.status === 200) {
          toastr.success("Sent 👍");
        }
      })
      .catch((error) => toastr.error(error))
      .finally(() => setLoading(false));
  };

  return (
    <Box sx={{ p: 3, m: "0 auto" }}>
      <Box sx={{ bgcolor: "#FFFFFF", p: 2, borderRadius: 5 }}>
        <Button onClick={send} variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : "Send Annual Statement"}
        </Button>
      </Box>
    </Box>
  );
};

export default SendAnnualStatement;
